import { AssetType } from "@zapier/canvas-state";

import { UnlinkedStatusIndicator } from "../UnlinkedStatusIndicator";
import { AgentToggle } from "./AgentToggle";
import { ZapToggle } from "./ZapToggle";

interface AssetToggleProps {
  assetId: string | null;
  assetType: AssetType;
}

export function AssetToggleOrStatus({ assetId, assetType }: AssetToggleProps) {
  if (assetType === "agent") {
    return <AgentToggle agentId={assetId} />;
  }

  if (assetType === "zap") {
    return <ZapToggle zapId={assetId} />;
  }

  if (assetType && !assetId) {
    return <UnlinkedStatusIndicator />;
  }

  return null;
}
